const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };
export {
  hasReducedMotionListener,
  prefersReducedMotion
};
//# sourceMappingURL=state.js.map
